import * as RadixProgress from "@radix-ui/react-progress";

const OnboardingProgressBar = ({
  currentIndex,
  totalSteps,
}: {
  currentIndex: number;
  totalSteps: number;
}) => {
  const progressPercent = Math.floor((currentIndex / totalSteps) * 100);

  return (
    <RadixProgress.Root
      className="relative h-1 w-full overflow-hidden rounded-full bg-zinc-200"
      value={progressPercent}
      style={{ transform: "translateZ(0)" }}
    >
      <RadixProgress.Indicator
        className="h-full rounded-full bg-spring transition-all duration-300 ease-in-out"
        style={{
          width: `${progressPercent}%`,
        }}
      />
    </RadixProgress.Root>
  );
};

export default OnboardingProgressBar;
